import React, {Component} from 'react';
import {withRouter} from "react-router-dom";
import Table from "@amzn/meridian/table";
import TableRow from "@amzn/meridian/table/table-row";
import TableCell from "@amzn/meridian/table/table-cell";
import {connect} from "react-redux";
import Link from "@amzn/meridian/link";
import {convertToString, getNodeId} from "../../Utility";
import {FormattedMessage} from "react-intl";
import {getDocumentURL} from "../../handler/ParentDataHandler";
import {getLocale} from "../../handler/LocaleHandler";
import Column from "@amzn/meridian/column";
import RefreshTimer from "../RefreshTimer";
import {navigationAdded} from "../../actions/OptionsActions";
import {
    getInductCount,
    getMachineStatus,
    getMachineTableData,
} from "../../actions/StowBufferAction";
import {refreshInterval} from "../../constants";
import Tooltip from "@amzn/meridian/tooltip";

class StowBufferTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sortColumn: "name",
            sortDirection: "ascending",
            baseURL: "",
            inductedCount: 0
        }
    }

    componentDidMount() {
        getDocumentURL().then(value => {
            this.setState({baseURL: value})
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.selectedCycle !== "" && prevProps.selectedCycle !== this.props.selectedCycle) {
            this.fetchDataForMachineTable(this.props.selectedCycle, getNodeId())
        }
    }

    fetchDataForMachineTable(selectedCycle, nodeId) {
        clearInterval(this.timer);
        this.getDataForMachineTable(selectedCycle, nodeId)
        this.timer = setInterval(async () => {
            if (!document.hidden) {
                this.getDataForMachineTable(selectedCycle, nodeId)
            }
        }, refreshInterval);
    }

    async getDataForMachineTable(selectedCycle, nodeId) {
        this.props.dispatch(getInductCount(selectedCycle, nodeId))
        await this.props.dispatch(getMachineTableData(nodeId, selectedCycle, 'ASSOCIATE'))
        this.props.dispatch(getMachineStatus(nodeId, this.props.machineList))
    }

    getPercentageOfStationVolume(machine) {
        if (parseInt(this.props.inductCount, 10) !== 0) {
            return (parseInt(machine.stowedBufferedPackages, 10) * 100 / parseInt(this.props.inductCount, 10))
                .toFixed(2).toString() + "%"
        } else {
            return "-"
        }
    }

    getFlyByRate(machine) {
        if (parseInt(machine.stowedBufferedPackages, 10) !== 0) {
            return (parseInt(machine.flyByRate, 10) * 100 / parseInt(machine.stowedBufferedPackages, 10)).toFixed(2).toString() + "%";
        } else {
            return "-"
        }
    }

    getNoReadRate(machine) {
        if (parseInt(machine.noReadRate, 10) + parseInt(machine.stowedBufferedPackages, 10) !== 0) {
            return (parseInt(machine.noReadRate, 10) * 100 / (parseInt(machine.noReadRate, 10) + parseInt(machine.stowedBufferedPackages, 10)))
                .toFixed(2).toString() + "%";
        } else {
            return "-"
        }
    }

    onMachineClick = (machine) => {
        this.props.dispatch(navigationAdded({
            value: machine
        }))

        this.props.history.push(`/bay/${machine}`)
    }

    onSort = (sortDetails) => {
        this.setState({
            sortColumn: sortDetails.sortColumn,
            sortDirection: sortDetails.sortDirection
        })
    }

    render() {
        const {selectedStatuses, machineList} = this.props;
        const filteredMachineList = machineList ? machineList.filter(function (machine) {
            return !selectedStatuses.length || selectedStatuses.includes(machine.status);
        }) : [];

        filteredMachineList && filteredMachineList.sort((a, b) => {
            const fieldA = a[this.state.sortColumn];
            const fieldB = b[this.state.sortColumn];

            if (this.state.sortDirection === "ascending") {
                return convertToString(fieldA)
                    .localeCompare(convertToString(fieldB), getLocale(), {numeric: true});
            } else {
                return convertToString(fieldB)
                    .localeCompare(convertToString(fieldA), getLocale(), {numeric: true});
            }
        })

        return (
            <Column>
                <RefreshTimer deps={[machineList]}/>
                <div style={{ overflowX: "auto", width: "100%" }}>
                    <Table headerRows={1} showDividers={false} showStripes={false} spacing="small"
                           fixHeaderRows={true}
                           fixHeaderRowsFullWidth={true}
                           headerColumns={1}
                           stickyHeaderColumn={true}
                           sortColumn={this.state.sortColumn}
                           sortDirection={this.state.sortDirection}
                           onSort={this.onSort} data-cy={"machineList"}>
                        <TableRow>
                            <TableCell sortColumn="name">
                                <Tooltip position="top"
                                         title="Name of the ADTA machine"
                                         id="tooltip.machine">
                                    <span tabIndex="0">
                                        <FormattedMessage id="stowBuffer.machine" defaultMessage="Machine"/>
                                    </span>
                                </Tooltip>
                            </TableCell>
                            <TableCell sortColumn="machineStatus">
                                <Tooltip position="top"
                                         title="PLC Machine is Active or Inactive"
                                         id="tooltip.machineStatus">
                                    <span tabIndex="0">
                                        <FormattedMessage id="stowBuffer.machineStatus" defaultMessage="Machine Status"/>
                                    </span>
                                </Tooltip>
                            </TableCell>
                            <TableCell sortColumn="fullBay" alignmentHorizontal="right">
                                <Tooltip position="top"
                                         title="Opens the bay level drilldown"
                                         id="tooltip.fullBay">
                                    <span tabIndex="0">
                                        <FormattedMessage id="stowBuffer.fullBay" defaultMessage="Full Bay"/>
                                    </span>
                                </Tooltip>
                            </TableCell>
                            <TableCell sortColumn="flyByRate" alignmentHorizontal="right">
                                <Tooltip position="top"
                                         title="Rate of packages going to the jackpot Bay wrt total packages processed by the finger in the cycle"
                                         id="tooltip.flyByRate">
                                    <span tabIndex="0">
                                        <FormattedMessage id="stowBuffer.flyByRate" defaultMessage="Jackpot rate"/>
                                    </span>
                                </Tooltip>
                            </TableCell>
                            <TableCell sortColumn="noReadRate" alignmentHorizontal="right">
                                <Tooltip position="top"
                                         title="Rate of NOREADS by the machine wrt total packages processed by the finger in the cycle"
                                         id="tooltip.noReadRate">
                                    <span tabIndex="0">
                                        <FormattedMessage id="stowBuffer.noReadRate" defaultMessage="No read rate"/>
                                    </span>
                                </Tooltip>
                            </TableCell>
                            <TableCell sortColumn="stowedBufferedPackages" alignmentHorizontal="right">
                                <Tooltip position="top"
                                         title="Volume processed by ADTA finger in current shift cycle"
                                         id="tooltip.machineCurrentVolume">
                                    <span tabIndex="0">
                                        <FormattedMessage id="stowBuffer.currentVolume" defaultMessage="Current Volume"/>
                                    </span>
                                </Tooltip>
                            </TableCell>
                            <TableCell sortColumn="stowedBufferedPackages" alignmentHorizontal="right">
                                <Tooltip position="top"
                                         title="Percentage of total packages processed by a finger wrt total packages diverted in a station in the cycle"
                                         id="tooltip.percentOfStationVolume">
                                    <span tabIndex="0">
                                        <FormattedMessage id="stowBuffer.percentOfStationVolume"
                                                        defaultMessage="% of Station Volume"/>
                                    </span>
                                </Tooltip>
                            </TableCell>
                            <TableCell sortColumn="pph" alignmentHorizontal="right">
                                <Tooltip position="top"
                                         title="Total volume processed by a finger averaged over the number of hours passed in the shift"
                                         id="tooltip.avgPPH">
                                    <span tabIndex="0">
                                        <FormattedMessage id="stowBuffer.avgPPH" defaultMessage="Avg PPH"/>
                                    </span>
                                </Tooltip>
                            </TableCell>
                        </TableRow>
                        {
                            filteredMachineList && filteredMachineList.map(machine => (
                                <TableRow key={machine.alias} data-cy={"associateDataRow"}>
                                    <TableCell>{machine.name}</TableCell>
                                    <TableCell>
                                        <span
                                            style={machine.status === "Inactive" ? {color: '#CC0C39'} : {color: "#ADE422"}}>{machine.status}</span>
                                    </TableCell>
                                    <TableCell alignmentHorizontal="right">
                                        <Link onClick={() => this.onMachineClick(machine.alias)}>{"Bay_Details"}</Link>
                                    </TableCell>
                                    <TableCell alignmentHorizontal="right">{this.getFlyByRate(machine)}</TableCell>
                                    <TableCell alignmentHorizontal="right">{this.getNoReadRate(machine)}</TableCell>
                                    <TableCell alignmentHorizontal="right">{machine.stowedBufferedPackages}</TableCell>
                                    <TableCell
                                        alignmentHorizontal="right">{this.getPercentageOfStationVolume(machine)}</TableCell>
                                    <TableCell alignmentHorizontal="right">{machine.pph}</TableCell>
                                </TableRow>
                            ))
                        }
                    </Table>
                </div>
            </Column>
        )
    }
}

const mapStateToProps = state => {
    return ({
        selectedStatuses: state.optionsReducer.options.machineStatuses,
        selectedCycle: state.optionsReducer.options.cycle,
        inductCount: state.stowBufferReducer.inductCount,
        machineList: state.stowBufferReducer.machineList
    });
}
export default withRouter(connect(mapStateToProps)(StowBufferTable));



// WEBPACK FOOTER //
// ./src/components/stowBuffer/StowBufferTable.js